import { customDateComparator } from '@/utils/tableGridUtils'
import { ColDef } from '@ag-grid-community/core'

export const GFRSummaryTableColumns: ColDef[] = [
  {
    field: 'analysisDate',
    filter: 'agDateColumnFilter',
    filterParams: {
      comparator: customDateComparator,
      buttons: ['reset'],
    },
  },
  {
    field: 'portfolioTotalRisk',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined) return ''
      const num = Number(params.value)
      if (Number.isNaN(num)) return params.value
      return num.toFixed(3)
    },
  },
  {
    field: 'benchmarkTotalRisk',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined) return ''
      const num = Number(params.value)
      if (Number.isNaN(num)) return params.value
      return num.toFixed(3)
    },
  },
  {
    field: 'activeTotalRisk',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined) return ''
      const num = Number(params.value)
      if (Number.isNaN(num)) return params.value
      return num.toFixed(3)
    },
  },
  {
    field: 'period_var',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined) return ''
      const num = Number(params.value)
      if (Number.isNaN(num)) return params.value
      return num.toFixed(3)
    },
  },
]
